import React from "react";
import Footer from "../components/footer";
import AppNav from "../components/appNav";
import HeroKitDigital from "../components/heroKitDigital";
import BannerSection from "../components/bannerSection";
import KitDigitalInfoSection from "../components/kitDigitalnfoSection";
import SolutionsSection from "../components/solutionsSection";
import SegmentsSection from "../components/segmentsSection";
import { useTranslation } from "react-i18next";

const KitDigitalPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>
      <main>
        <HeroKitDigital
          title={t("Digital Kit Program")}
          text={t("¡Transforma tu Negocio Hoy!")}
        />
        <BannerSection />
        <KitDigitalInfoSection />
        <SolutionsSection />
        <SegmentsSection />
        <BannerSection />

        <section className="swiss-section">
          <div className="swiss-grid">
            <div className="col-span-12">
              <p className="swiss-caption text-center">
                {t(
                  "Proyecto desarrollado en el marco de los fondos europeos 'Next Generation EU' dentro del Plan de Recuperación Transformación y Resiliencia"
                )}
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default KitDigitalPage;
